export type TimeEntryStatus = "ACTIVE" | "COMPLETED" | "EDITED";
export type TimesheetStatus = "DRAFT" | "SUBMITTED" | "APPROVED" | "REJECTED";

export interface TimeEntry {
  id: string;
  employee_id: string;
  employee_name?: string;
  timesheet_id?: string;
  project_id?: string | null;
  project_code?: string;
  project_name?: string;
  is_billable?: boolean;
  clock_in: string;
  clock_out?: string;
  hours?: number;
  notes?: string;
  status: TimeEntryStatus;
  created_at: string;
}

export interface Project {
  id: string;
  org_id: string;
  code: string;
  name: string;
  client?: string | null;
  description?: string | null;
  is_billable: boolean;
  hourly_rate?: number | null;
  currency: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface TimesheetPolicy {
  id: string;
  org_id: string;
  weekly_overtime_threshold: number;
  daily_overtime_threshold: number;
  require_project_on_entry: boolean;
  auto_submit_on_friday: boolean;
  default_hourly_rate?: number | null;
  created_at: string;
  updated_at: string;
}

export interface WeeklyGridCell {
  date: string;
  hours: number;
  is_billable_hours: number;
  entries: number;
}

export interface WeeklyGridProjectRow {
  project_id: string | null;
  project_code: string | null;
  project_name: string | null;
  is_billable: boolean;
  total_hours: number;
  cells: WeeklyGridCell[];
}

export interface WeeklyGridResponse {
  week_start: string;
  week_end: string;
  employee_id: string;
  total_hours: number;
  regular_hours: number;
  overtime_hours: number;
  billable_hours: number;
  rows: WeeklyGridProjectRow[];
}

export interface PendingReviewRow {
  timesheet_id: string;
  employee_id: string;
  employee_name: string;
  week_start: string;
  week_end: string;
  total_hours: number;
  regular_hours: number;
  overtime_hours: number;
  submitted_at: string | null;
}

export interface Timesheet {
  id: string;
  employee_id: string;
  employee_name?: string;
  week_start: string;
  week_end: string;
  total_hours: number;
  regular_hours: number;
  overtime_hours: number;
  status: TimesheetStatus;
  submitted_at?: string;
  approved_by?: string;
  approved_at?: string;
  notes?: string;
  entries: TimeEntry[];
  created_at: string;
}

export const TIMESHEET_STATUS_LABELS: Record<TimesheetStatus, string> = {
  DRAFT: "Draft",
  SUBMITTED: "Submitted",
  APPROVED: "Approved",
  REJECTED: "Rejected",
};

export const TIME_ENTRY_STATUS_LABELS: Record<TimeEntryStatus, string> = {
  ACTIVE: "Clocked In",
  COMPLETED: "Completed",
  EDITED: "Edited",
};
